(()=>{
const esc=s=>String(s??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
const metals={yellow:'#c3a264',white:'#f2f0e9',rose:'#c79683',silver:'#b1b3b6',gold:'#c3a264'};
const CHAIN_CURVE=[[10,41.2],[11,43.05],[12,44.525],[13,46.3],[14,47.9],[15,49.25],[16,50.45],[17,51.7],[18,52.7],[19,53.75],[20,54.75],[21,55.65],[22,56.425],[23,57.4],[24,58.25],[25,58.95],[26,59.7],[27,60.4],[28,60.95],[29,61.525],[30,62.0],[31,62.5],[32,63.225],[33,63.5],[34,63.85],[35,64.45],[36,64.8],[37,65.1],[38,65.6],[39,65.85],[40,66.1],[41,66.5],[42,66.625],[43,66.9],[44,67.05],[45,67.25],[46,67.4],[47,67.5],[48,67.5],[49,67.6],[50,67.55],[51,67.6],[52,67.65],[53,67.6],[54,67.5],[55,67.65],[56,67.3],[57,67.2],[58,67.05],[59,66.75],[60,66.6],[61,66.3],[62,66.1],[63,65.75],[64,65.4],[65,65.1],[66,64.6],[67,64.3],[68,63.8],[69,63.35],[70,62.8],[71,62.35],[72,61.8],[73,61.15],[74,60.55],[75,59.75],[76,59.25],[77,58.55],[78,57.8],[79,56.85],[80,56.1],[81,55.15],[82,54.0],[83,53.05],[84,51.95],[85,50.85],[86,49.55],[87,48.15],[88,46.5],[89,45.0],[90,43.4]];
const uri=s=>'data:image/svg+xml;charset=utf-8,'+encodeURIComponent(s);

function charmImage(item,metal){
  const c=metals[metal]||metals.yellow;
  let body='';
  if(item.letter)body=`<text x="50" y="76" text-anchor="middle" font-family="Georgia,serif" font-size="65" fill="${c}" stroke="#795c32" stroke-width=".5">${esc(item.letter)}</text>`;
  else if(item.shape==='pearl')body='<circle cx="50" cy="54" r="27" fill="url(#pearl)" stroke="#ddd6c9"/>';
  else if(item.shape==='star')body=`<path d="M50 20 L59 42 L83 45 L64 60 L70 84 L50 70 L30 84 L36 60 L17 45 L41 42Z" fill="${c}"/>`;
  else body=`<${item.shape==='prong'?'rect x="28" y="31" width="44" height="44" transform="rotate(45 50 53)"':'circle cx="50" cy="54" r="25"'} fill="#fcfcfa" stroke="${c}" stroke-width="7"/><path d="M31 53L50 33L69 53L50 74Z M31 53H69 M50 33V74" fill="none" stroke="#d7d8d9" stroke-width="1.4"/>`;
  return uri(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 110"><defs><radialGradient id="pearl" cx="35%" cy="25%"><stop stop-color="white"/><stop offset="1" stop-color="#d4cec1"/></radialGradient></defs><ellipse cx="50" cy="13" rx="7" ry="10" fill="none" stroke="${c}" stroke-width="4"/>${body}</svg>`);
}

function chainImage(metal){
  const c=metals[metal]||metals.yellow;
  return uri(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 800"><path d="M155 -30 C190 90 200 470 400 485 C600 470 610 90 645 -30" fill="none" stroke="#806636" stroke-width="7"/><path d="M155 -30 C190 90 200 470 400 485 C600 470 610 90 645 -30" fill="none" stroke="${c}" stroke-width="5" stroke-dasharray="3 3"/><path d="M155 -30 C190 90 200 470 400 485 C600 470 610 90 645 -30" fill="none" stroke="#fff8" stroke-width="1.2"/></svg>`);
}

function demoData(){
  const chains=['yellow','white','rose'].map((m,i)=>({
    id:'chain-'+m,
    name:m[0].toUpperCase()+m.slice(1)+' gold',
    metal:m,
    price:45000,
    available:true
  }));
  const charms=[];
  ['yellow','white','rose'].forEach(m=>{
    ['Audrey','Avery'].forEach(range=>{
      for(let i=0;i<26;i++){
        const letter=String.fromCharCode((range==='Audrey'?65:97)+i);
        charms.push({
          id:`${range}-${letter}-${m}`,
          name:`${range} ${letter}`,
          group:range,
          letter,
          metal:m,
          price:range==='Audrey'?24000:22000,
          available:true
        });
      }
    });
    [
      ['Bubble','bubble',19500],
      ['Four prong','prong',21000],
      ['Pearl','pearl',9500],
      ['Haylie étoile','star',17500]
    ].forEach(([name,shape,price])=>charms.push({
      id:name+'-'+m,
      name,
      shape,
      group:'Other',
      metal:m,
      price,
      available:true
    }));
  });
  return{demo:true,currency:'AUD',chains,charms};
}

class EtuiBuilder extends HTMLElement {
  connectedCallback() {
    if (this.shadowRoot) return;
    const raw = this.querySelector('script[type="application/json"]');
    const config = raw ? JSON.parse(raw.textContent) : null;
    this.data = config ? {...config, demo:false} : demoData();
    this.copy = this.querySelector('template[data-builder-copy]')?.innerHTML;
    const limit = Number(this.data.maxCharms);
    this.maxCharms = Number.isInteger(limit) && limit >= 1 && limit <= 5 ? limit : 5;
    this.selected = Array(this.maxCharms).fill(null);
    this.blankSlots = new Set();
    this.activeSlot = 0;
    this.pendingSizes = new Map();
    this.galleryScroll = 0;
    this.group = this.data.charms[0]?.group || '';
    this.chain = this.data.chains.find(c => c.available) || this.data.chains[0];
    this.attachShadow({mode:'open'});
    this.render();
  }

  get count() {
    return this.selected.filter(Boolean).length;
  }

  get canPlace() {
    return Number.isInteger(this.activeSlot) &&
      this.activeSlot >= 0 &&
      this.activeSlot < this.maxCharms;
  }

  label(charm) {
    if (!charm) return 'Blank';
    if (
      charm.productName &&
      charm.optionLabel &&
      charm.name === charm.optionLabel &&
      charm.optionLabel !== charm.productName
    ) {
      return charm.productName + ' — ' + charm.optionLabel;
    }
    return charm.name;
  }

  image(item) {
    return item.image || (
      this.data.demo
        ? charmImage(item, this.chain?.metal)
        : uri('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 110"><text x="50" y="55" text-anchor="middle" font-size="10" fill="#81776b">No image</text></svg>')
    );
  }

  money(n) {
    return new Intl.NumberFormat('en-AU', {
      style:'currency',
      currency:this.data.currency || 'AUD'
    }).format(n / 100);
  }

  total() {
    return (this.chain?.price || 0) +
      this.selected.reduce((n,c) => n + (c?.price || 0), 0);
  }

  nextOpen(after) {
    for (let step = 1; step <= this.maxCharms; step++) {
      const i = (after + step) % this.maxCharms;
      if (!this.selected[i] && !this.blankSlots.has(i)) return i;
    }
    return null;
  }

  chooseSlot(i) {
    if (!Number.isInteger(i) || i < 0 || i >= this.maxCharms) return;
    this.blankSlots.delete(i);
    this.activeSlot = i;
    this.render();
  }

  placeCharm(id) {
    const charm = this.data.charms.find(c => String(c.id) === String(id));
    if (!this.canPlace || !charm?.available || charm.metal !== this.chain?.metal) return;
    const i = this.activeSlot;
    this.selected[i] = charm;
    this.blankSlots.delete(i);
    this.activeSlot = this.nextOpen(i);
    this.render();
  }

  leaveBlank(i) {
    if (!Number.isInteger(i) || i < 0 || i >= this.maxCharms) return;
    this.selected[i] = null;
    this.blankSlots.add(i);
    if (this.activeSlot === i || !this.canPlace) this.activeSlot = this.nextOpen(i);
    this.render();
  }

  moveCharm(i, direction) {
    const j = i + direction;
    if (!this.selected[i] || j < 0 || j >= this.maxCharms) return;
    [this.selected[i], this.selected[j]] = [this.selected[j], this.selected[i]];
    for (const position of [i,j]) {
      if (this.selected[position]) this.blankSlots.delete(position);
      else this.blankSlots.add(position);
    }
    if (this.activeSlot === i || this.activeSlot === j) this.activeSlot = this.nextOpen(j);
    this.render();
  }

  payload() {
    const id = globalThis.crypto?.randomUUID?.() || Date.now() + '-' + Math.random();
    const order = this.selected.map((c,i) => `${i+1}: ${this.label(c)}`).join(' | ');
    return {items:[
      {
        id:this.chain.id,
        quantity:1,
        properties:{
          'Charm order (left to right)':order,
          'Layout direction':'Left to right as shown in the necklace builder preview',
          _necklace_build:id
        }
      },
      ...this.selected.flatMap((c,i) => c ? [{
        id:c.id,
        quantity:1,
        properties:{
          'Charm position':String(i+1),
          _necklace_build:id
        }
      }] : [])
    ]};
  }

  attachmentPoint(x) {
    const first=CHAIN_CURVE[0], last=CHAIN_CURVE[CHAIN_CURVE.length-1];
    if(x<=first[0]) return [x,first[1]];
    if(x>=last[0]) return [x,last[1]];
    const right=CHAIN_CURVE.findIndex(point=>point[0]>=x);
    const leftPoint=CHAIN_CURVE[right-1], rightPoint=CHAIN_CURVE[right];
    const fraction=(x-leftPoint[0])/(rightPoint[0]-leftPoint[0]);
    return [x,leftPoint[1]+fraction*(rightPoint[1]-leftPoint[1])];
  }

  charmPositions(spacing) {
    const path=CHAIN_CURVE.map((point,i)=>({
      x:point[0],
      y:point[1],
      distance:0
    }));

    for(let i=1;i<path.length;i++) {
      path[i].distance=path[i-1].distance+
        Math.hypot(path[i].x-path[i-1].x,path[i].y-path[i-1].y);
    }

    const distanceAt=x=>{
      if(x<=path[0].x)return 0;
      if(x>=path[path.length-1].x)return path[path.length-1].distance;
      const index=path.findIndex(point=>point.x>=x);
      const a=path[index-1], b=path[index];
      return a.distance+(x-a.x)/(b.x-a.x)*(b.distance-a.distance);
    };

    const pointAt=distance=>{
      if(distance<=0)return [path[0].x,path[0].y];
      if(distance>=path[path.length-1].distance) {
        return [path[path.length-1].x,path[path.length-1].y];
      }
      const index=path.findIndex(point=>point.distance>=distance);
      const a=path[index-1], b=path[index];
      const fraction=(distance-a.distance)/(b.distance-a.distance);
      return [a.x+fraction*(b.x-a.x),a.y+fraction*(b.y-a.y)];
    };

    const centre=distanceAt(50);
    const half = (this.maxCharms - 1) / 2;

    if (half === 0) return [pointAt(centre)];

    const step = Math.min(
      centre-distanceAt(50-half*spacing),
      distanceAt(50+half*spacing)-centre
    )/half;

    return Array.from(
      {length:this.maxCharms},
      (_,i)=>pointAt(centre+(i-half)*step)
    );
  }

  render() {
    const previousTrack = this.shadowRoot.querySelector('[data-gallery-track]');
    if (previousTrack) this.galleryScroll = previousTrack.scrollLeft;

    const chain = this.chain;
    const isOther = g => this.data.groups?.find(t => t.id === g)?.combined === true;
    const matched = this.data.charms.filter(
      c => c.metal && c.metal === chain?.metal && (!isOther(c.group) || c.available)
    );
    const groups = [...new Set(matched.map(c => c.group))];

    if (!groups.includes(this.group)) this.group = groups[0] || '';

    const choices = matched.filter(c => c.group === this.group);
    const spacing = typeof getComputedStyle === 'function'
      ? Math.max(6,Math.min(
          20,
          parseFloat(getComputedStyle(this).getPropertyValue('--charm-spacing')) || 12
        ))
      : 12;

    const positions = this.charmPositions(spacing);
    const chainSrc = chain?.image || (
      this.data.demo
        ? chainImage(chain?.metal)
        : uri('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 800"><text x="400" y="400" text-anchor="middle" font-size="20" fill="#81776b">Select a chain and upload its necklace image</text></svg>')
    );

    const instruction = this.canPlace
      ? `Choose a charm for position ${this.activeSlot+1}${this.selected[this.activeSlot] ? ' to replace its current charm' : ''}.`
      : 'Select a numbered position to add or replace a charm.';

    this.shadowRoot.innerHTML = `<style>${EtuiBuilder.styles}</style>
      <div class="layout">
        <div class="visual">
          <div class="stage">
            <img class="chain" alt="Necklace chain preview" src="${esc(chainSrc)}">
            <div class="overlay">
              ${this.selected.map((c,i) => c ? `<img class="pendant" alt="${esc(this.label(c))} in position ${i+1}" src="${esc(this.image(c))}" style="left:${positions[i][0]}%;top:${positions[i][1]}%">` : '').join('')}
            </div>
          </div>
          <p class="preview-note">${this.data.demo ? 'Illustrated prototype · Sample images and AUD prices' : 'Design preview · Image proportions are illustrative'}<br>Position 1 starts from the left. Empty positions stay blank.</p>
          ${this.renderGallery()}
        </div>
        <div class="config">
          ${this.copy ?? '<span class="eyebrow">A little piece of you</span><h1>Étui Charms Necklace</h1><p class="intro">Your initials. Your favourites. Your story.<br>Choose your chain and add your favourite charms to make it yours.</p>'}

          <div class="label">
            <strong>01. Choose your chain</strong>
            <span>${this.money(chain?.price || 0)}</span>
          </div>

          ${this.renderChainSelectors()}

          <div class="label">
            <strong>02. Pick your charms</strong>
            <span>${this.count} / ${this.maxCharms} selected</span>
          </div>

          <p class="position-hint" aria-live="polite">${instruction}</p>

          <div class="tabs" role="group" aria-label="Charm ranges">
            ${groups.map(g => `<button class="tab ${g === this.group ? 'active' : ''}" data-group="${esc(g)}" aria-pressed="${g === this.group}">${esc(this.data.groups?.find(item => item.id === g)?.label || (g === 'Audrey' ? 'Audrey · A–Z' : g === 'Avery' ? 'Avery · a–z' : g))}</button>`).join('')}
          </div>

          <div class="grid ${isOther(this.group) ? 'other-grid' : ''}">
            ${this.renderChoices(choices, isOther(this.group))}
          </div>

          <div class="label">
            <strong>03. Your charm positions</strong>
            <span>Left → right</span>
          </div>

          <p class="slot-help">Select a position to fill or replace it. Choose “Leave blank” to keep a gap.</p>

          <div class="slots" role="group" aria-label="${this.maxCharms} fixed charm ${this.maxCharms === 1 ? 'position' : 'positions'}, left to right">
            ${this.selected.map((c,i) => `<div class="slot ${c ? 'filled' : ''} ${this.activeSlot === i ? 'slot-active' : ''}">
              <button class="slot-select" data-slot="${i}" aria-pressed="${this.activeSlot === i}" aria-label="Select position ${i+1}${c ? ': '+esc(this.label(c)) : ': Blank'}">
                <span class="number">${i+1}</span>
                ${c ? `<img alt="" src="${esc(this.image(c))}"><span class="name" title="${esc(this.label(c))}">${esc(this.label(c))}</span>` : '<span class="blank-label">Blank</span><span class="slot-add">+ Choose</span>'}
              </button>
              ${c ? `<div class="controls"><button data-move="${i},-1" aria-label="Move position ${i+1} charm left" ${i === 0 ? 'disabled' : ''}>‹</button><button data-blank="${i}" aria-label="Remove charm and leave position ${i+1} blank">×</button><button data-move="${i},1" aria-label="Move position ${i+1} charm right" ${i === this.maxCharms - 1 ? 'disabled' : ''}>›</button></div>` : `<button class="leave-blank" data-blank="${i}" ${this.blankSlots.has(i) ? 'disabled' : ''}>${this.blankSlots.has(i) ? 'Kept blank' : 'Leave blank'}</button>`}
            </div>`).join('')}
          </div>

          <div class="tools">
            <span style="font-size:11px;color:#8c8171">Choose the same charm more than once, or leave gaps.</span>
            <button class="text-button" data-clear>Start again</button>
          </div>

          <div class="total">
            <span>Your Total</span>
            <strong class="amount">${this.money(this.total())}</strong>
          </div>

          <p class="breakdown">Chain ${this.money(chain?.price || 0)} + charms ${this.money(this.total()-(chain?.price || 0))}</p>

          <button class="add" data-add ${!chain?.available || !this.count ? 'disabled' : ''}>
            ${this.data.demo ? 'ADD TO DEMO BAG' : 'ADD TO BAG'}
          </button>

          <div class="status" aria-live="polite">${this.data.demo ? 'Prototype only. No payment or real order will be created.' : ''}</div>
          <div class="bag" hidden></div>
        </div>
      </div>`;

    this.bind();
  }

  renderGallery() {
    const images = (this.data.gallery || []).filter(image => image.src);
    if (!images.length || this.data.showGallery === false) return '';

    return `<section class="necklace-gallery" aria-label="${esc(this.data.galleryHeading || 'Necklace inspiration')}">
      <div class="gallery-heading">
        <h2>${esc(this.data.galleryHeading || 'Necklace inspiration')}</h2>
        <div class="gallery-buttons">
          <button data-gallery-prev aria-label="Previous necklace photos">‹</button>
          <button data-gallery-next aria-label="Next necklace photos">›</button>
        </div>
      </div>
      <div class="gallery-track" data-gallery-track tabindex="0" aria-label="Necklace photos; scroll horizontally to browse">
        ${images.map(image => `<figure class="gallery-slide"><img src="${esc(image.src)}" alt="${esc(image.alt || 'Sample necklace')}" loading="lazy" width="${Number(image.width)||600}" height="${Number(image.height)||600}"></figure>`).join('')}
      </div>
    </section>`;
  }

  renderChainSelectors() {
    const definitions = this.data.chainOptions?.length
      ? this.data.chainOptions
      : [{name:'Colour', values:[...new Set(this.data.chains.map(c => c.name))]}];

    return `<div class="chain-selectors">${definitions.map((definition,index) => {
      const current = this.chain?.options?.[index] ?? this.chain?.name;
      return `<label class="chain-field">
        <span>${esc(definition.name)}</span>
        <span class="select-wrap">
          <select data-chain-option="${index}" aria-label="${esc(definition.name)}">
            ${definition.values.map(value => `<option value="${esc(value)}" ${value === current ? 'selected' : ''}>${esc(value)}</option>`).join('')}
          </select>
        </span>
      </label>`;
    }).join('')}</div>`;
  }

  changeChain(next) {
    if (!next?.available) {
      this.shadowRoot.querySelector('.status').textContent =
        'This chain combination is unavailable. Please choose another colour or length.';
      return false;
    }

    if (next.metal !== this.chain?.metal && this.count) {
      const mapped = this.selected.map(c => c
        ? this.data.charms.find(v =>
            (v.productId ?? v.group) === (c.productId ?? c.group) &&
            (v.identity ?? v.name) === (c.identity ?? c.name) &&
            v.metal &&
            v.metal === next.metal &&
            v.available
          )
        : null
      );

      if (mapped.some((c,i) => this.selected[i] && !c)) {
        this.shadowRoot.querySelector('.status').textContent =
          'Some selected charms are unavailable in that colour. Remove those charms before changing colour.';
        return false;
      }

      this.selected = mapped;
    }

    this.chain = next;
    this.render();
    return true;
  }

  renderChoices(choices, combined) {
    if (!choices.length) {
      return '<p class="empty-charms">No matching charms available. Check that the chain and charm products both have a Colour option with matching values.</p>';
    }

    const button = c => `<button class="choice" data-charm="${esc(c.id)}" aria-label="Add ${esc(this.label(c))}, ${this.money(c.price)}" ${c.available && this.canPlace ? '' : 'disabled'}>
      <img alt="" src="${esc(this.image(c))}">
      <small>${esc(c.letter || c.optionLabel || c.name)}</small>
      <span class="price">${this.money(c.price)}${c.available ? '' : ' · Sold out'}</span>
    </button>`;

    if (!combined) return choices.map(button).join('');

    const products = new Map();

    choices.forEach(c => {
      const key = c.productId ?? c.group;
      if (!products.has(key)) products.set(key,[]);
      products.get(key).push(c);
    });

    return [...products.values()].map(items => {
      const key = String(items[0].productId ?? items[0].group) +
        '|' + String(this.chain?.metal || '');
      const active = items.find(
        c => String(c.id) === String(this.pendingSizes?.get(key))
      ) || items[0];

      const hasSize = items.some(c => c.hasSize === true);
      const needsSelector = hasSize || items.length > 1;
      const productName = active.productName || active.name;

      const selector = needsSelector
        ? `<label class="other-size-label">
            <span>${hasSize ? 'Size' : 'Option'}</span>
            <span class="select-wrap">
              <select data-product-size="${esc(key)}" aria-label="${hasSize ? 'Size' : 'Option'} for ${esc(productName)}">
                ${items.map(c => `<option value="${esc(c.id)}" ${c === active ? 'selected' : ''}>${esc(c.optionLabel || c.sizeLabel || c.name)}</option>`).join('')}
              </select>
            </span>
          </label>`
        : '';

      return `<section class="other-product">
        <button class="other-card" data-charm="${esc(active.id)}" aria-label="Add ${esc(this.label(active))}, ${this.money(active.price)}" ${active.available && this.canPlace ? '' : 'disabled'}>
          <img class="other-image" src="${esc(this.image(active))}" alt="">
          <span class="other-name">${esc(productName)}</span>
          <span class="other-price">${this.money(active.price)}</span>
          <span class="other-add">+ Add charm</span>
        </button>
        ${selector}
      </section>`;
    }).join('');
  }

  bind() {
    const root = this.shadowRoot;

    root.querySelectorAll('[data-group]').forEach(button =>
      button.onclick = () => {
        this.group=button.dataset.group;
        this.render();
      }
    );

    root.querySelectorAll('[data-slot]').forEach(button =>
      button.onclick = () => this.chooseSlot(Number(button.dataset.slot))
    );

    root.querySelectorAll('[data-charm]').forEach(button =>
      button.onclick = () => this.placeCharm(button.dataset.charm)
    );

    root.querySelectorAll('[data-blank]').forEach(button =>
      button.onclick = () => this.leaveBlank(Number(button.dataset.blank))
    );

    root.querySelectorAll('[data-move]').forEach(button =>
      button.onclick = () => {
        const [i,d] = button.dataset.move.split(',').map(Number);
        this.moveCharm(i,d);
      }
    );

    root.querySelectorAll('[data-product-size]').forEach(select =>
      select.onchange = () => {
        const variant = this.data.charms.find(
          c => String(c.id) === String(select.value)
        );
        if (!variant?.available || variant.metal !== this.chain?.metal) return;
        this.pendingSizes.set(select.dataset.productSize,variant.id);
        this.render();
      }
    );

    root.querySelector('[data-clear]').onclick = () => {
      this.selected=Array(this.maxCharms).fill(null);
      this.blankSlots.clear();
      this.activeSlot=0;
      this.render();
    };

    root.querySelectorAll('[data-chain-option]').forEach(select =>
      select.onchange = () => {
        const inputs = [...root.querySelectorAll('[data-chain-option]')];
        const values = inputs.map(input => input.value);
        const next = this.data.chains.find(c =>
          c.options
            ? c.options.every((value,index) => value === values[index])
            : c.name === values[0]
        );

        if (!this.changeChain(next)) {
          inputs.forEach((input,index) =>
            input.value=this.chain?.options?.[index] ?? this.chain?.name ?? ''
          );
        }
      }
    );

    root.querySelector('[data-add]').onclick = () => this.add();

    const track = root.querySelector('[data-gallery-track]');

    if (track) {
      const previous = root.querySelector('[data-gallery-prev]');
      const next = root.querySelector('[data-gallery-next]');

      const update = () => {
        this.galleryScroll = track.scrollLeft;
        previous.disabled = track.scrollLeft <= 1;
        next.disabled = track.scrollWidth - track.clientWidth - track.scrollLeft <= 1;
      };

      track.scrollLeft = this.galleryScroll || 0;
      track.addEventListener('scroll',update,{passive:true});

      const reduced = typeof matchMedia === 'function' &&
        matchMedia('(prefers-reduced-motion: reduce)').matches;

      previous.onclick = () => track.scrollBy({
        left:-track.clientWidth,
        behavior:reduced?'auto':'smooth'
      });

      next.onclick = () => track.scrollBy({
        left:track.clientWidth,
        behavior:reduced?'auto':'smooth'
      });

      update();
    }
  }

  async add() {
    const root = this.shadowRoot;
    if (!this.count || !this.chain?.available) return;

    const button = root.querySelector('[data-add]');
    button.disabled = true;
    const payload = this.payload();

    if (this.data.demo) {
      const bag = root.querySelector('.bag');
      bag.hidden = false;
      bag.innerHTML = `<h3>Your sample bag</h3>
        <strong>${esc(this.chain.name)} chain</strong>
        <ul>${this.selected.map((c,i) => `<li>Position ${i+1}: ${esc(this.label(c))}${c ? ' · '+this.money(c.price) : ''}</li>`).join('')}</ul>
        <strong>Total ${this.money(this.total())}</strong>`;

      root.querySelector('.status').textContent =
        'Your demo necklace has been added. No real order was created.';
      button.disabled = false;
      return;
    }

    try {
      const base = window.Shopify?.routes?.root || '/';
      const response = await fetch(base+'cart/add.js',{
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify(payload)
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(
          result.description ||
          'Unable to add the necklace. Please check your bag before retrying.'
        );
      }

      window.location.assign(base+'cart');
    } catch(error) {
      root.querySelector('.status').textContent = error.message;
      button.disabled = false;
    }
  }
}

EtuiBuilder.styles = `
:host{display:block;color:#302d28;font-family:var(--font-body-family,inherit);font-style:var(--font-body-style,normal);font-weight:var(--font-body-weight,400);font-size:14px}
*{box-sizing:border-box}
button,select{font:inherit;color:inherit}
button{cursor:pointer}
button:disabled{cursor:not-allowed;opacity:.45}
.layout{display:grid;grid-template-columns:1.1fr 1fr;gap:64px;max-width:1180px;margin:auto;padding:42px 28px}
.visual{position:sticky;top:24px;align-self:start}
.stage{position:relative;aspect-ratio:1;background:#f3f0ea;border-radius:2px;overflow:hidden}
.chain{width:100%;height:100%;object-fit:contain}
.overlay{position:absolute;inset:0;pointer-events:none}
.pendant{position:absolute;transform:translate(calc(-1 * var(--charm-anchor-x,54%)),calc(-1 * var(--charm-anchor-y,8%)));width:var(--charm-size,12%);height:auto;object-fit:contain;object-position:center top;filter:drop-shadow(1px 3px 2px #0002)}
.preview-note{text-align:center;color:#787168;font-size:12px;margin-top:17px;line-height:1.7}
.eyebrow{font-size:10px;text-transform:uppercase;letter-spacing:2px;color:#807465}
h1{font-family:var(--font-heading-family,inherit);font-style:var(--font-heading-style,normal);font-weight:var(--font-heading-weight,400);font-size:40px;margin:13px 0 20px;line-height:1.1}
.intro{color:#746e65;line-height:1.7;margin-bottom:26px}
.label{display:flex;justify-content:space-between;align-items:center;margin:24px 0 12px;font-size:12px}
.label strong{font-weight:600}
.metals,.tabs{display:flex;gap:7px;flex-wrap:wrap}
.pill,.tab{background:white;border:1px solid #ddd6cc;border-radius:30px;padding:10px 15px;font-size:12px}
.active{background:#e8e1d5;border-color:#8b7b65}
.swatch{display:inline-block;width:11px;height:11px;border-radius:50%;border:1px solid #b9b0a2;margin-right:7px}
.tabs{margin-bottom:15px}
.grid{display:grid;grid-template-columns:repeat(6,1fr);gap:7px;max-height:none;overflow:visible;padding:1px}
.choice{border:1px solid #e5dfd5;background:#faf9f6;min-height:83px;padding:9px 3px;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:5px}
.choice:hover{border-color:#9c8769;background:#f0ebe1}
.choice img{width:38px;height:38px}
.choice small{font-size:10px}
.choice .price{color:#81776b;font-size:9px}
.slots{display:flex;gap:8px}
.slot{flex:1;min-width:0;min-height:100px;border:1px dashed #d3cabc;background:#faf9f6;position:relative;text-align:center;padding:8px 2px}
.slot.filled{border-style:solid}
.slot img{width:30px;height:35px}
.slot .number{font-size:10px;color:#8c8171;display:block;margin-bottom:5px}
.slot .name{font-size:10px;display:block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.controls{display:flex;justify-content:center;gap:2px;margin-top:6px}
.controls button{border:0;background:transparent;padding:2px 4px;font-size:13px}
.total{display:flex;justify-content:space-between;border-top:1px solid #ddd5c8;padding-top:23px;margin-top:25px;align-items:center}
.amount{font-size:25px;font-family:var(--font-heading-family,inherit)}
.breakdown{font-size:11px;color:#7a7166;margin:10px 0 18px}
.add{width:100%;padding:17px;border:0;background:#34382d;color:white;letter-spacing:1px;font-size:12px}
.status{min-height:24px;font-size:12px;margin-top:12px;line-height:1.5}
.tools{display:flex;justify-content:space-between;margin-top:15px}
.text-button{background:none;border:0;text-decoration:underline;color:#817465;font-size:11px}
.bag{padding:18px;background:#f2eee6;margin-top:16px;line-height:1.7}
.bag h3{font-family:var(--font-heading-family,inherit);font-size:21px;font-weight:normal;margin:0 0 10px}
.bag ul{padding-left:18px}
.bag[hidden]{display:none}

@media(max-width:800px){
  .layout{grid-template-columns:1fr;gap:25px;padding:20px}
  .visual{position:relative;top:0}
  .stage{max-width:560px;margin:auto}
  h1{font-size:33px}
  .grid{grid-template-columns:repeat(5,1fr)}
}

.grid.other-grid{grid-template-columns:repeat(2,minmax(0,1fr));gap:12px;align-items:start}
.other-product{min-width:0;padding:14px;border:1px solid #e5dfd5;background:#faf9f6}
.other-product h3{font-family:var(--font-heading-family,inherit);font-weight:var(--font-heading-weight,400);font-size:16px;line-height:1.35;margin:0 0 12px;overflow-wrap:anywhere}
.size-choices{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:6px}
.size-choices .choice{min-width:0;background:#fffdf9;padding:9px 4px}
.size-choices .choice:only-child{grid-column:1/-1}
.size-choices .choice small{white-space:normal;overflow-wrap:anywhere;line-height:1.35}
.empty-charms{grid-column:1/-1}

@media(max-width:480px){
  .grid.other-grid{grid-template-columns:1fr}
}

.chain-selectors{display:grid;gap:16px}
.chain-field{display:grid;gap:8px;font-size:14px}
.select-wrap{position:relative;display:block}
.select-wrap:after{content:"";position:absolute;right:18px;top:45%;width:9px;height:9px;border-right:1.5px solid currentColor;border-bottom:1.5px solid currentColor;transform:rotate(45deg);pointer-events:none}
.chain-field select{appearance:none;-webkit-appearance:none;display:block;width:100%;padding:16px 42px 16px 18px;border:1px solid #8b8983;border-radius:0;background:transparent;font:inherit;color:inherit;cursor:pointer}
.chain-field select:focus-visible{outline:2px solid currentColor;outline-offset:3px}

.grid.other-grid{grid-template-columns:repeat(3,minmax(0,1fr));gap:10px;align-items:stretch}
.other-product{padding:0;border:1px solid #e5dfd5;background:#faf9f6;display:flex;flex-direction:column;min-width:0}
.other-card{display:flex;flex-direction:column;align-items:center;gap:9px;width:100%;padding:16px 9px;border:0;background:transparent;text-align:center;flex:1}
.other-card:hover{background:#f0ebe1}
.other-card:focus-visible{outline:2px solid currentColor;outline-offset:-3px}
.other-image{width:100%;height:90px;object-fit:contain}
.other-name{font-family:var(--font-heading-family,inherit);font-style:var(--font-heading-style,normal);font-weight:var(--font-heading-weight,400);font-size:14px;line-height:1.35;overflow-wrap:anywhere}
.other-price{font-size:12px;color:#746e65}
.other-add{font-size:10px;text-transform:uppercase;letter-spacing:.6px;margin-top:auto;padding-top:5px}
.other-size-label{display:grid;gap:5px;padding:0 9px 12px;font-size:11px;margin-top:auto}
.other-size-label select{appearance:none;-webkit-appearance:none;width:100%;border:1px solid #bdb4a6;border-radius:0;padding:9px 25px 9px 7px;background:#fffdf9;font:inherit;color:inherit;cursor:pointer}
.other-size-label .select-wrap:after{right:10px;width:6px;height:6px;top:40%}
.other-size-label select:focus-visible{outline:2px solid currentColor;outline-offset:2px}

@media(max-width:800px){
  .grid.other-grid{grid-template-columns:repeat(2,minmax(0,1fr))}
}

.visual{min-width:0}
.config{min-width:0}
.position-hint,.slot-help{font-size:12px;line-height:1.5;color:#746e65;margin:0 0 13px}
.slot{padding:0 2px 6px;display:flex;flex-direction:column}
.slot-active{outline:2px solid #8b7b65;outline-offset:2px;background:#f0ebe1}
.slot-select{width:100%;padding:8px 2px;border:0;background:transparent;min-height:79px;text-align:center;flex:1}
.slot-select:focus-visible,.leave-blank:focus-visible{outline:2px solid currentColor;outline-offset:1px}
.blank-label{display:block;font-size:11px;color:#81776b}
.slot-add{display:block;font-size:10px;color:#81776b;margin-top:7px}
.leave-blank{border:0;background:transparent;font-size:9px;text-decoration:underline;padding:5px 1px;color:#81776b}
.necklace-gallery{margin-top:25px;min-width:0}
.gallery-heading{display:flex;gap:12px;align-items:center;justify-content:space-between;margin-bottom:12px}
.gallery-heading h2{font-family:var(--font-heading-family,inherit);font-weight:var(--font-heading-weight,400);font-style:var(--font-heading-style,normal);font-size:18px;line-height:1.3;margin:0}
.gallery-buttons{display:flex;gap:6px}
.gallery-buttons button{display:grid;place-items:center;width:32px;height:32px;border:1px solid #d3cabc;background:transparent;font-size:22px;line-height:1}
.gallery-buttons button:focus-visible{outline:2px solid currentColor;outline-offset:2px}
.gallery-track{display:flex;gap:10px;overflow-x:auto;scroll-snap-type:x mandatory;overscroll-behavior-x:contain;scrollbar-width:none}
.gallery-track::-webkit-scrollbar{display:none}
.gallery-track:focus-visible{outline:2px solid currentColor;outline-offset:3px}
.gallery-slide{flex:0 0 calc((100% - 20px)/3);min-width:0;margin:0;scroll-snap-align:start}
.gallery-slide img{width:100%;height:auto;aspect-ratio:1;object-fit:cover;display:block;background:#f3f0ea}

@media(max-width:480px){
  .gallery-slide{flex-basis:calc((100% - 10px)/2)}
}

.etui-product-info {
  margin: 24px 0 28px;
  border-top: 1px solid currentColor;
  border-bottom: 1px solid currentColor;
}
.etui-product-info__heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 16px 0;
  cursor: pointer;
  list-style: none;
  font: inherit;
  font-weight: 600;
  color: inherit;
}
.etui-product-info__heading::-webkit-details-marker {
  display: none;
}
.etui-product-info__heading::marker {
  content: '';
}
.etui-product-info__heading:focus-visible {
  outline: 2px solid currentColor;
  outline-offset: 4px;
}
.etui-product-info__icon {
  position: relative;
  display: block;
  flex: 0 0 14px;
  width: 14px;
  height: 14px;
}
.etui-product-info__icon::before,
.etui-product-info__icon::after {
  content: '';
  position: absolute;
  background: currentColor;
}
.etui-product-info__icon::before {
  width: 14px;
  height: 1px;
  left: 0;
  top: 6px;
}
.etui-product-info__icon::after {
  width: 1px;
  height: 14px;
  left: 6px;
  top: 0;
}
.etui-product-info[open] .etui-product-info__icon::after {
  display: none;
}
.etui-product-info__content {
  padding: 0 0 18px;
  font: inherit;
  color: inherit;
  line-height: 1.65;
  overflow-wrap: anywhere;
}
.etui-product-info__content p {
  margin: 0 0 12px;
}
.etui-product-info__content ul,
.etui-product-info__content ol {
  margin: 0 0 12px;
  padding-left: 24px;
}
.etui-product-info__content ul {
  list-style: disc outside;
}
.etui-product-info__content ol {
  list-style: decimal outside;
}
.etui-product-info__content li {
  display: list-item;
  margin: 0 0 6px;
}
.etui-product-info__content a {
  color: inherit;
  text-decoration: underline;
}
.etui-product-info__content > :last-child {
  margin-bottom: 0;
}
`;

if(!customElements.get('etui-builder')){
  customElements.define('etui-builder',EtuiBuilder);
}
})();

/* Mobile: preview above the total, gallery below the buy area */
(() => {
  const Builder = customElements.get('etui-builder');
  if (!Builder || Builder.reviewLayoutInstalled) return;

  Builder.reviewLayoutInstalled = true;

  Builder.styles += `
    @media (max-width: 800px) {
      .visual {
        position: static !important;
        top: auto !important;
        width: 100%;
        margin: 24px 0;
        padding: 0;
        box-shadow: none;
        border: none;
      }

      .visual .stage {
        width: 100%;
        max-width: 560px;
        margin: 0 auto;
      }

      .visual .preview-note {
        font-size: 11px;
        margin: 10px 0 0;
      }

      .config > .necklace-gallery {
        margin-top: 26px;
      }
    }
  `;

  function arrange(builder) {
    const root = builder.shadowRoot;
    if (!root) return;

    const mobile = window.matchMedia('(max-width: 800px)').matches;
    const visual = root.querySelector('.visual');
    const config = root.querySelector('.config');
    const total = root.querySelector('.total');
    const gallery = root.querySelector('.necklace-gallery');

    if (mobile) {
      if (gallery && config) config.appendChild(gallery);
      if (visual && total) total.before(visual);
    } else {
      if (visual && config) config.before(visual);
      if (gallery && visual) visual.appendChild(gallery);
    }

    root.querySelector('[data-gallery-track]')
      ?.dispatchEvent(new Event('scroll'));
  }

  const originalRender = Builder.prototype.render;

  Builder.prototype.render = function (...args) {
    const result = originalRender.apply(this, args);
    arrange(this);
    return result;
  };

  function refreshBuilders() {
    document.querySelectorAll('etui-builder').forEach(builder => {
      if (builder.shadowRoot) builder.render();
    });
  }

  window.matchMedia('(max-width: 800px)')
    .addEventListener('change', refreshBuilders);

  document.addEventListener('shopify:section:load', refreshBuilders);

  refreshBuilders();
})();

/* Click gallery images to enlarge */
(() => {
  const Builder = customElements.get('etui-builder');
  if (!Builder || Builder.galleryLightboxAdded) return;

  Builder.galleryLightboxAdded = true;

  Builder.styles += `
    .gallery-open {
      display: block;
      width: 100%;
      padding: 0;
      border: 0;
      background: transparent;
      cursor: zoom-in;
    }

    .gallery-open:focus-visible {
      outline: 2px solid currentColor;
      outline-offset: -3px;
    }

    .gallery-lightbox {
      width: min(94vw, 1100px);
      max-width: 94vw;
      max-height: 92vh;
      max-height: 92dvh;
      margin: auto;
      padding: 48px 16px 16px;
      border: 0;
      background: white;
      color: #302d28;
      overflow: auto;
    }

    .gallery-lightbox::backdrop {
      background: rgba(0, 0, 0, 0.75);
    }

    .gallery-lightbox img {
      display: block;
      width: 100%;
      height: auto;
      max-height: 75vh;
      max-height: 75dvh;
      object-fit: contain;
    }

    .gallery-lightbox-close {
      position: absolute;
      top: 8px;
      right: 10px;
      width: 36px;
      height: 36px;
      padding: 0;
      border: 0;
      background: transparent;
      font-size: 30px;
      line-height: 1;
      cursor: pointer;
    }
  `;

  function enableLightbox(builder) {
    const root = builder.shadowRoot;
    if (!root) return;

    root.querySelectorAll('.gallery-slide img').forEach(image => {
      if (image.closest('.gallery-open')) return;

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'gallery-open';
      button.setAttribute(
        'aria-label',
        'Enlarge ' + (image.alt || 'necklace photo')
      );

      image.before(button);
      button.appendChild(image);

      button.addEventListener('click', () => {
        root.querySelector('.gallery-lightbox')?.remove();

        const dialog = document.createElement('dialog');
        dialog.className = 'gallery-lightbox';
        dialog.setAttribute('aria-label', 'Enlarged necklace photo');

        const close = document.createElement('button');
        close.type = 'button';
        close.className = 'gallery-lightbox-close';
        close.setAttribute('aria-label', 'Close enlarged photo');
        close.textContent = '×';

        const enlarged = document.createElement('img');
        enlarged.src = image.src;
        enlarged.alt = image.alt || 'Necklace photo';

        dialog.append(close, enlarged);
        root.appendChild(dialog);

        close.onclick = () => dialog.close();

        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;

          const box = dialog.getBoundingClientRect();

          if (
            event.clientX < box.left ||
            event.clientX > box.right ||
            event.clientY < box.top ||
            event.clientY > box.bottom
          ) {
            dialog.close();
          }
        });

        dialog.addEventListener('close', () => {
          dialog.remove();
          if (button.isConnected) button.focus({preventScroll: true});
        }, {once: true});

        dialog.showModal();
      });
    });
  }

  const originalRender = Builder.prototype.render;

  Builder.prototype.render = function (...args) {
    const result = originalRender.apply(this, args);
    enableLightbox(this);
    return result;
  };

  document.querySelectorAll('etui-builder').forEach(builder => {
    if (builder.shadowRoot) builder.render();
  });
})();

/* Builder label and selector fonts */
(() => {
  const Builder = customElements.get('etui-builder');
  if (!Builder) return;

  Builder.styles += `
    .label,
    .position-hint,
    .chain-field,
    .chain-field select,
    .tab {
      font-family: var(--font-heading-family, inherit);
      font-style: var(--font-heading-style, normal);
      font-weight: var(--font-heading-weight, 400);
    }
  `;

  document.querySelectorAll('etui-builder').forEach(builder => {
    if (builder.shadowRoot) builder.render();
  });
})();

/* Adjustable circular arc for charm attachment points */
(() => {
  const Builder = customElements.get('etui-builder');
  if (!Builder || Builder.adjustableCurveAdded) return;

  Builder.adjustableCurveAdded = true;

  const tracedPositions = Builder.prototype.charmPositions;

  Builder.prototype.charmPositions = function (existingSpacing) {
    const css = getComputedStyle(this);

    if (css.getPropertyValue('--curve-mode').trim() !== 'arc') {
      return tracedPositions.call(this, existingSpacing);
    }

    const number = (name, fallback) => {
      const value = parseFloat(css.getPropertyValue(name));
      return Number.isFinite(value) ? value : fallback;
    };

    const spacing = Math.max(
      1,
      number('--charm-spacing', 12)
    );

    const curve = Math.max(
      0,
      Math.min(100, number('--curve-depth', 60))
    );

    const x = number('--curve-x', 50);
    const y = number('--curve-y', 67);

    const half = (this.maxCharms - 1) / 2;
    if (half === 0) return [[x, y]];

    if (curve === 0) {
      return Array.from({length: this.maxCharms}, (_, i) => [
        x + (i - half) * spacing,
        y
      ]);
    }

    const halfWidth = spacing * half;
    const depth = halfWidth * curve / 100;

    const radius = (
      halfWidth * halfWidth + depth * depth
    ) / (2 * depth);

    const halfAngle = 2 * Math.atan(depth / halfWidth);

    return Array.from({length: this.maxCharms}, (_, i) => {
      const angle = (i - half) * halfAngle / half;

      return [
        x + radius * Math.sin(angle),
        y - radius * (1 - Math.cos(angle))
      ];
    });
  };

  document.querySelectorAll('etui-builder').forEach(builder => {
    if (builder.shadowRoot) builder.render();
  });
})();